import React, { PureComponent, Component } from 'react';
import './index.less';

class RowItem extends (PureComponent || Component) {
	render () {
		const {label, info, width, children} = this.props;
		const style = 'rowItem';
		return (
			<div className={`${style}`}>
				<div className={`${style}-label`} style={{'width': width || ''}}>
					{label}
				</div>
				<div className={`${style}-info`}>
					{info}
				</div>
				<div className={`${style}-inner-content`}>
					{children}
				</div>
			</div>
		);
	}
}
export default RowItem;
